import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

/**
 * Legal documents.
 *
 * The text is served by the API from `legal_documents` (versioned, editable from
 * the admin screen) so that changing the EULA does not require a deployment and
 * so that the version a user accepted can be pinned in `consents`.
 *
 * Until that endpoint is wired to this screen the page states plainly that the
 * text is not loaded, rather than showing a placeholder that a user could
 * mistake for the agreement.
 */
export function LegalPage(): React.ReactNode {
  const { t } = useTranslation();
  const { document } = useParams<{ document: string }>();

  const titleKey =
    document === 'privacy' ? 'footer.privacy' : document === 'cookies' ? 'footer.cookies' : 'footer.eula';

  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <h1 className="text-2xl font-bold">{t(titleKey)}</h1>
      <p className="mt-4 text-sm text-[var(--color-muted-fg)]">
        {t('legal.notLoaded')}
      </p>
      <p className="mt-3 text-xs text-[var(--color-muted-fg)]">
        {t('legal.scopeNote')}
      </p>
    </div>
  );
}
